var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full"},[_c('div',{ref:"mathJaxEl",staticClass:"maximizer",attrs:{"tabindex":"-1","id":"chat-output"},domProps:{"innerHTML":_vm._s(_vm.output)}})])}
var staticRenderFns = []

export { render, staticRenderFns }